// extracted by mini-css-extract-plugin
export default {"navMenu":"App_navMenu__TV5N7","link":"App_link__VM4Pq","activeLink":"App_activeLink__wnFST"};